<div id="content-section">
  <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '720px' : '420px' }">
    <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '700px' : '400px' }" style="position: fixed; right: 20px; overflow-y: scroll; z-index: 1037 !important">
      <div class="sticky-top">
        <small class="bg-white">
          <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
            <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
          </a>
        </small>
      </div>
      <app-contact-sidebar #contactSidebar [contact_id]="contactId"></app-contact-sidebar>
    </div>
    <div id="content-inner" class="responsive-content-inner" style="padding: 10px 20px 10px 20px">
      <div class="container-shadow px-3 pb-4">
        <div class="p-5 text-center" *ngIf="loadingContactInfo">
          <i class="fas fa-5x fa-spinner fa-fw fa-pulse"></i>
        </div>
        <div *ngIf="!loadingContactInfo && contactInfo">
          <h2 class="pt-3">{{ contactInfo.name }}</h2>
          <hr />
          <div class="row">
            <div class="col-sm-6">
              <span *ngIf="contactInfo.address_default" [innerHTML]="contactInfo.address_default"></span>&nbsp;
              <app-clipboard-btn *ngIf="contactInfo.address_default_clipboard" [errorNotificationMessage]="'Error copying address'" [content]="contactInfo.address_default_clipboard" [successNotificationMessage]="'Address copied'" [title]="'Copy Address'"></app-clipboard-btn>
            </div>
            <div class="col-sm-6">
              <span *ngIf="contactInfo.primary_phone">{{ contactInfo.primary_phone }}</span>
              &nbsp;
              <app-clipboard-btn *ngIf="contactInfo.primary_phone" [errorNotificationMessage]="'Error copying phone'" [content]="contactInfo.primary_phone" [successNotificationMessage]="'Phone copied'" [title]="'Copy Phone'"></app-clipboard-btn>
              <br />
              <a title="Send Email" [href]="'mailto:' + contactInfo.primary_email" *ngIf="contactInfo.primary_email">{{ contactInfo.primary_email }}</a>
              &nbsp;
              <app-clipboard-btn *ngIf="contactInfo.primary_email" [errorNotificationMessage]="'Error copying email'" [content]="contactInfo.primary_email" [successNotificationMessage]="'Email copied'" [title]="'Copy Email'"></app-clipboard-btn>
            </div>
          </div>
          <hr />
          <p [innerHTML]="contactInfo.notes"></p>
          <hr *ngIf="contactInfo && contactInfo.employer_id && contactInfo.employer_name" />
          <p *ngIf="contactInfo.employer_id && contactInfo.employer_name">
            <b>Employer:&nbsp;</b>
            <a [routerLink]="'/contacts/' + contactInfo.employer_id">
              {{ contactInfo.employer_name }}
            </a>
          </p>
          <hr *ngIf="contactInfo && contactInfo.employees && contactInfo.employees.length > 0" />
          <div *ngIf="contactInfo && contactInfo.employees && contactInfo.employees.length > 0">
            <b>Employees</b>
            <br />
            <ul>
              <li *ngFor="let employee of contactInfo.employees">
                <a [routerLink]="'/contacts/' + employee.id">
                  {{ employee.name }}
                </a>
              </li>
            </ul>
          </div>
          <hr *ngIf="contactInfo && contactInfo.url" />
          <iframe id="contact_url_iframe" [hidden]="!contactInfo.url" width="100%" height="600" sandbox="" style="border: none" border="0"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
